import i18n from '@/i18n';
import { carOptions } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const CarOptions = () => import('./views/Index.vue');

export default [
  {
    path: 'car-options',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.CarOptions`,
        component: CarOptions,
        meta: {
          title: i18n.global.t('carOptions.carOptions'),
          permission: { module: carOptions.module, key: carOptions.showAll },
        },
      },
    ],
  },
];
